module.exports = __webpack_public_path__ + "img/2026-spring.9760a0c3.png";